import { API } from '../config/AppConfig';
import {
  ADD_COMMENT,
  CHART_ACCURACY_BREAKDOWN,
  CQ_REVENUE_OPP,
  DASHBOARD_RVU_OPP_BREAKDOWN,
  GET_AUDITSHEET_COMMENTS,
  GET_DASHBOARD_CQ_SCORE,
  UPDATE_ACCURACY_REVIEW_STATUS,
  UPLOAD_CHART_ACTIVITY,
} from '../constants/Endpoints';
import { applyDateType } from '../utils/common.utils';

class BatchDashboardRepository {
  async getBatchCQScore(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(GET_DASHBOARD_CQ_SCORE, { queryParams: finalParams });
    return response;
  }

  async getoutStandingRevOpp(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(CQ_REVENUE_OPP, { queryParams: finalParams });
    return response;
  }

  async getOutStandingRevOppBreakDown(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(DASHBOARD_RVU_OPP_BREAKDOWN, {
      queryParams: finalParams,
    });
    return response;
  }

  async getChartAccuracyData(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(CHART_ACCURACY_BREAKDOWN, {
      queryParams: finalParams,
    });
    return response;
  }

  async getUploadChartActivity(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(UPLOAD_CHART_ACTIVITY, { queryParams: finalParams });
    return response;
  }
  async getAuditRebuttalComments(queryParams) {
    const response = await API.get(GET_AUDITSHEET_COMMENTS, {
      pathParams: { batchId: queryParams.batch_id },
      queryParams
    });
    return response;
  }

  async addComment(commentBody) {
    const response = await API.post(ADD_COMMENT, {
      body: commentBody,
    });
    return response;
  }

  async updateAccuracyReviewStatus(rowData) {
    try {
        // const { chart_id, location, review } = rowData;
        const response = await API.put(UPDATE_ACCURACY_REVIEW_STATUS, {
            body: rowData
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to update review status');
    }
  }
}

const batchDashboardRepository = new BatchDashboardRepository();
export default batchDashboardRepository;
